export default "__VITE_ASSET__7852e5fc__"